<template>
  <div class="table-setting-menus">
    <!-- icons -->
    <a-tooltip v-if="record.isEnable === 1" placement="bottom">
      <template v-slot:title>
        <span>{{$t("Sample6")}}</span>
      </template>
      <FormOutlined
        class="setting-menu-icon"
        @click="() => toggleModal('editVisible')"
      />
    </a-tooltip>
    <a-tooltip v-if="record.isEnable === 1" placement="bottom">
      <template v-slot:title>
        <span>{{$t("Sample1")}}</span>
      </template>
      <CloseCircleOutlined
        class="setting-menu-icon"
        @click="() => toggleModal('deleteVisible')"
      />
    </a-tooltip>

    <!-- modals -->
    <SampleUploadEditModal
      v-if="editVisible"
      mode="edit"
      :visible="editVisible"
      :toggleModal="() => toggleModal('editVisible')"
      :attachInfo="record"
    />
    <SampleDeleteModal
      v-if="deleteVisible"
      :visible="deleteVisible"
      :toggleModal="() => toggleModal('deleteVisible')"
      :attachInfo="record"
    />
  </div>
</template>

<script>
import { computed, reactive, ref, toRefs } from "vue";
import { FormOutlined, CloseCircleOutlined } from "@ant-design/icons-vue";
import SampleUploadEditModal from "@/components/sideComponents/SampleUploadEditModal";
import SampleDeleteModal from "@/components/sideComponents/SampleDeleteModal";

export default {
  name: "SampleSettingMenu",
  props: {
    record: Object,
  },
  components: {
    FormOutlined,
    CloseCircleOutlined,
    SampleUploadEditModal,
    SampleDeleteModal,
  },
  setup(props) {
    const state = reactive({
      editVisible: false,
      deleteVisible: false,
    });

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    return {
      ...toRefs(state),
      toggleModal,
    };
  },
};
</script>